"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const gradients = {
  blueAccent: 'radial-gradient(ellipse at 0% 100%, hsl(191, 100%, 97%) 0%,hsl(194, 100%, 92%) 100%)',
  blueAccentTranslucent: 'radial-gradient(ellipse at 0% 100%, hsla(191, 100%, 97%, 0.5) 0%,hsla(194, 100%, 92%, 0.5) 100%)',
  blueGreen: 'linear-gradient(135deg, hsl(202, 100%, 95%) 0%,hsl(174, 82%, 95%) 100%)',
  blueGreenTranslucent: 'linear-gradient(135deg, hsla(202, 100%, 95%, 0.5) 0%,hsla(174, 82%, 95%, 0.5) 100%)',
  orangeRed: 'linear-gradient(135deg, hsl(355, 100%, 97%) 0%,hsl(14, 100%, 97%) 50%,hsl(323, 100%, 97%) 100%)',
  orangeRedTranslucent: 'linear-gradient(135deg, hsl(355, 100%, 97%) 0%,hsl(14, 100%, 97%) 50%,hsl(323, 100%, 97%) 100%)',
  teal: 'linear-gradient(135deg, hsl(176, 60%, 95%) 0%,hsl(185, 44%, 95%) 100%)',
  tealTranslucent: 'linear-gradient(135deg, hsla(176, 60%, 95%, 0.5) 0%,hsla(185, 44%, 95%, 0.5) 100%)',
  justfly: 'linear-gradient(135deg, #EFF5FF 0%,#F5F5F5 100%)',
  component: {
    header: {
      background: 'linear-gradient(135deg, #EFF5FF 0%,#F5F5F5 100%)'
    },
    page: {
      background: 'linear-gradient(135deg, #EFF5FF 0%,#F5F5F5 100%)'
    }
  }
};
var _default = exports.default = gradients;